import React from 'react';
export function Footer() {
  return <footer className="text-white py-12 px-4 mt-16" style={{
    backgroundColor: '#bc8a60'
  }} data-id="element-1">
      <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-2">
        <p className="text-xs text-white" data-id="element-3">
          © 2026 VentoroPro. All Rights Reserved.
        </p>
        <p className="text-xs text-white max-w-2xl mx-auto leading-relaxed" data-id="element-4">
          This is an advertisement and not an actual news article, blog, or
          consumer protection update. Results may vary. Individual experiences
          shared represent personal testimonials and are not guaranteed outcomes
          for all users.
        </p>
        <div className="flex justify-center space-x-6 text-xs text-white" data-id="element-5">
          <a href="#" className="hover:opacity-80 underline" data-id="element-6">
            Terms of Service
          </a>
          <a href="#" className="hover:opacity-80 underline" data-id="element-7">
            Privacy Policy
          </a>
          <a href="#" className="hover:opacity-80 underline" data-id="element-8">
            Shipping Policy
          </a>
          <a href="#" className="hover:opacity-80 underline" data-id="element-9">
            Contact Us
          </a>
        </div>
      </div>
    </footer>;
}